import React from "react";
import {
    DeliveryInfoPageContent
} from "@shopcrate/shopcrate-framework";

import Helmet from "../../../components/Helmet";

import bannerImage from "../../../img/top_10_kantoorplanten.jpg";

function DeliveryInfo() {
    return (
        <React.Fragment>
            <Helmet title="Gegevens"/>
            <div className="jumbotron jumbotron-fluid jumbotron-header jumbotron-sm" style={ { backgroundImage: "url(" + bannerImage + ")" } }>
                <div className="container">
                    <h1 className="text-white">Gegevens</h1>
                </div>
            </div>
            <div className="container mb-5">
                <DeliveryInfoPageContent/>
            </div>
        </React.Fragment>
    );
}

export default React.memo(DeliveryInfo);
